import { FaIcon } from '@/lib/fa'
import { Checkbox } from '@/ui'
import * as React from 'react'
import {
  SelectedGroup,
  useGroupsForm,
} from '@/modules/drivers/context/GroupsFormContext'
import { GroupModel } from '@/app/models/groupModel'

type Props = {
  group: GroupModel
  solidIcon: any
  regularIcon: any
  disabled?: boolean
  defaultChecked?: boolean
}

const GroupsListItem = ({
  group,
  solidIcon,
  regularIcon,
  disabled = false,
  defaultChecked = null,
}: Props) => {
  const { isSelected, toggleGroup } = useGroupsForm()
  const checked = isSelected(group.id)

  const onChange = () => {
    if (disabled) return
    toggleGroup({ id: group.id, name: group.name } as SelectedGroup)
  }

  return (
    <div className="tw-mx-2 tw-flex tw-items-center tw-gap-4 tw-border-t tw-border-base-300 tw-px-2 tw-py-4">
      <div>
        <Checkbox
          checked={defaultChecked || checked}
          disabled={defaultChecked || disabled}
          onChange={() => onChange()}
        />
      </div>
      <div
        className={`tw-flex tw-items-center tw-gap-2 tw-text-content-base ${checked ? 'tw-text-medium' : 'tw-text-base'} `}
      >
        <FaIcon
          icon={checked ? solidIcon : regularIcon}
          className="tw-color-content-base tw-cursor-pointer"
          onClick={() => onChange()}
        />
        <p>{group.name}</p>
      </div>
    </div>
  )
}

export default GroupsListItem
